import FeedBack from '@/types/feedBack';
import { FeedBackStateInterface } from './types';
import { ActionContext } from 'vuex';

export default {
  setFeedback(
    store: ActionContext<FeedBackStateInterface, any>,
    feedBack: FeedBack
  ): void {
    store.commit('setFeedBack', feedBack);
  },
};
